import React, {
  FC,
} from 'react';
import {
  SvgIconProps,
} from '@mui/material/SvgIcon';
import clsx from 'clsx';
import {
  formatMoney,
} from '@populateui/utils';

type Part = 'root' | 'title' | 'icon' | 'value' | 'icon';

type Props = {
  title: string;
  value: number;
  className?: string;
  classes?: Partial<Record<Part, string>>;
  Icon: FC<SvgIconProps>;
};
export default function SummaryTotalItem({
  className,
  classes,
  title,
  value,
  Icon,
}: Props) {
  return (
    <div className={clsx(
      'flex relative w-48 items-center !bg-transparent border rounded-md cursor-default pt-3 px-2 pb-2 gap-2',
      className,
      classes?.root,
    )}
    >
      <div className={clsx('font-semibold text-xs absolute left-1 -top-2 bg-white px-2 text-black', classes?.title)}>{title}</div>
      <div className={clsx('bg-blue-400 h-6 w-6 justify-center items-center flex text-white rounded-md', classes?.icon)}>
        <Icon className="!text-white !h-5 !w-5" />
      </div>
      <div className={clsx('text-base font-semibold !bg-transparent', classes?.value)}>
        {formatMoney(value ?? 0)}
      </div>
    </div>
  );
}
